<template>
  <div class="tabs-widget">
    <div class="tabs-links">
      <div class="tab" style="justify-content: flex-start" :class="{ active: switch_tab == 'overview' }"
        @click="selectTab('overview')">
        <span class="name">Overview</span>
      </div>

      <div class="tab" :class="{ active: switch_tab == 'projects' }" @click="selectTab('projects')">
        <span class="name">Projects</span>
      </div>
      <div class="tab" :class="{ active: switch_tab == 'contacts' }" @click="selectTab('contacts')">
        <span class="name">Contacts</span>
      </div>

      <div class="tab" :class="{ active: switch_tab == 'attachments' }" @click="selectTab('attachments')">
        <span class="name">Attachements</span>
      </div>

      <div class="tab" :class="{ active: switch_tab == 'notes' }" @click="selectTab('notes')">
        <span class="name">Notes</span>
      </div>
      <div class="tab" :class="{ active: switch_tab == 'activities' }" @click="selectTab('activities')">
        <span class="name">Activities</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "account-sidebar",
  components: {},
  props: {
    switch_tab: {
      type: String,
      default: "",
    },
    account: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => {
    return {};
  },
  watch: {},
  mounted() { },
  methods: {
    selectTab(type) {
      let vm = this;
      let path = [
        {
          label: "Accounts",
          path: "/accounts/list",
        },
        {
          label: type,
        },
      ];
      path.push({
        label: vm.account.name,
        active: true,
      });
      vm.$store.commit("SET_PATH", path);
      vm.$router
        .push({
          name: "account-view",
          params: { type: type, id: vm.$route.params.id },
        })
        .catch((error) => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs-widget {
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 134px;
  height: max-content;
  border-bottom: 1px solid #efefef;
  border-radius: 5px;
  overflow: auto;
  margin-right: 5px;
  padding: 12px 16px;

  @media (min-width: 300px) and (max-width: 630px) {
    flex-direction: row;
    justify-content: center;
  }

  .tabs-links {
    height: calc(100% - 168px);

    @media (min-width: 300px) and (max-width: 630px) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: unset;
      overflow-y: unset;
    }

    .tab {
      cursor: pointer;
      height: 35px;
      display: flex;
      align-items: center;
      position: relative;

      @media (min-width: 300px) and (max-width: 630px) {
        font-size: 11px;
      }

      .name {
        display: block;
        color: #707070;

        @media (min-width: 300px) and (max-width: 630px) {
          display: none;
        }
      }
    }

    .tab:hover {
      transition: 0.3s ease-in-out;

      .name {
        color: #1ba5a4;
        transition: 0.3s ease-in-out;
      }
    }

    .tab.active {
      .name {
        color: #1ba5a4;
      }

      .icon {
        background: #1890a9;
      }
    }
  }
}
</style>
